<ng-container *ngIf="ready; else progressing">
  <app-general-correspondence-thread-view [generalCorrespondence]="generalCorrespondence"></app-general-correspondence-thread-view>
</ng-container>

<ng-template #progressing>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
